import React from 'react';
import { Link } from 'react-router-dom';

function FAQ() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* SCHEMA ORGANIZED TITLE */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Medical Tourism in India FAQ: Critical Information for Cross-Border Patients
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', margin: 0 }}>
          Get immediate answers to high-volume questions regarding private hospital cost quotes, electronic medical visa document checklists, and independent verification protocols via the <strong>Medical Trip World</strong> reference venue.
        </p>
      </header>

      {/* EXPANDED FAQ CONTENT FOR HEAVY ORGANIC TRAFFIC */}
      <section style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', gap: '25px' }}>
        
        {/* CORE CORE INFRASTRUCTURE UTILITIES */}
        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: Does Medical Trip World coordinate airline flights or book private corporate hospital beds directly?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> No. Medical Trip World does not provide logistics assets, manage commercial travel files, handle emergency admissions, or operate corporate healthcare services. Our platform functions solely as an independent informational directory and research portal. All financial agreements, treatment plans, and appointment timelines are arranged directly and explicitly between the patient and their self-selected healthcare facility.
          </p>
        </div>

        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: How can an international patient independently audit active private hospital accreditations?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Although our independent directory profiles historical data metrics for private multi-specialty setups, we strongly recommend that cross-border travelers directly query the live, public registries maintained by Joint Commission International (JCI) or the National Accreditation Board for Hospitals (NABH) before scheduling treatment.
          </p>
        </div>

        {/* IMMIGRATION & REGULATORY TRAFFIC TARGETS */}
        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: What are the criteria for receiving an electronic Medical Visa Invitation Letter (VIL)?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Legally binding Medical Visa Invitation Letters are issued solely by licensed private corporate hospitals in India following a direct review of your diagnostics. Medical Trip World does not process visas, issue legal immigration entry papers, or coordinate with embassies. We supply open informational guidelines and template forms to help patients structure their document files before making direct contact.
          </p>
        </div>

        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: What is the standard processing time for an Indian e-Medical Visa in 2026?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Official immigration processing timelines generally range from 3 to 5 business days after online fee submission. However, unexpected documentation requests or administrative review queues can introduce delays. We advise organizing your private hospital invitation parameters at least 3 weeks prior to departure to ensure seamless entry clearances.
          </p>
        </div>

        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: Can an international medical visa be extended if the recovery cycle takes longer than expected?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Yes. Prolonged clinical stays can be accommodated by submitting a digital extension request through the official Foreigners Regional Registration Office (FRRO) portal. This process requires a certified medical certificate signed directly by an authorized medical consultant from an empaneled private hospital specifying the necessary recovery days.
          </p>
        </div>

        {/* FINANCIAL & COST OPTIMIZATION KEYWORDS */}
        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: Are the medical treatment cost estimates on this platform absolute or legally binding?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> No. All cost matrices, comparative price graphs, and economic estimation sheets are aggregated strictly for educational reference and benchmarking purposes. Final medical pricing schedules are subject to change based on actual clinical presentations and are determined exclusively via direct private contracts between the patient and the healthcare provider.
          </p>
        </div>

        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: What unlisted or hidden costs should international patients budget for?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Standard surgery quotes from private hospitals typically cover the procedural fee, basic room charges, and initial surgical materials. Patients must budget separately for prolonged ICU stays if complications arise, special post-discharge medications, localized physical therapy, and extended accommodation rentals for the mandatory outpatient recovery window.
          </p>
        </div>

        {/* LOGISTICS & SUPPORT CORRIDORS */}
        <div style={{ borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: Do corporate private hospitals in major medical hubs provide language translation assistance?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Yes. The international patient care departments of leading private multi-specialty systems across top medical cities deploy on-site translation staff proficient in Arabic, French, Russian, Uzbek, and Swahili to guide families smoothly through clinical assessments.
          </p>
        </div>

        <div>
          <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.1rem, 4.5vw, 1.25rem)', marginBottom: '8px', lineHeight: '1.4' }}>
            Q: How should a patient securely transfer treatment funds to an Indian hospital?
          </h3>
          <p style={{ margin: '0', lineHeight: '1.7', color: '#444', fontSize: '0.95rem' }}>
            <strong>A:</strong> Most elite private networks facilitate direct international wire transfers (SWIFT), multi-currency credit transactions, or verified local bank drafts. Because Medical Trip World remains completely unaligned and handles no payment portals or escrow setups, we strongly recommend coordinating payment instructions directly with the billing office of your chosen clinical facility before flying.
          </p>
        </div>

      </section>

    </article>
  );
}

export default FAQ;